import { render } from "./filtersContents.vue?vue&type=template&id=6fa0d658&scoped=true"
import script from "./filtersContents.vue?vue&type=script&lang=js"
export * from "./filtersContents.vue?vue&type=script&lang=js"

import "./filtersContents.vue?vue&type=style&index=0&id=6fa0d658&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa0d658"]])

export default __exports__